import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
//import { Event } from "../models/event.model";
import 'parse';
const parse: typeof Parse = require('parse');
//import { ParseFunctionService } from "./parsefunction.service";
import { environment } from '../../environments/environment';
import { Globals } from '../GlobalsExport';

@Injectable()
export class ParseService {
  hasLoad = false;
  constructor(public _globals: Globals) {
    this.initialize();
  }

  initialize() {
    //private parseFun: ParseFunctionService
    console.log('CONFIG PARSE:',this._globals);
    if (this._globals.localParse) {
      parse.initialize(environment.parseIDLocal, environment.parseKEYLocal);
      parse.serverURL = environment.parseAPILocal;
    } else {
      parse.initialize(environment.parseID, environment.parseKEY);
      parse.serverURL = environment.parseAPI;
      parse.liveQueryServerURL = environment.parseLive;
    }
    if (this._globals.role == '') {
      //this.getRoles(_globals);
    }
  }

  getRoles(globals) {
    const adminRoleQuery = new parse.Query(parse.Role);
    adminRoleQuery.equalTo('users', parse.User.current());
    adminRoleQuery.find().then(function (adminRole) {
      adminRole.forEach(element => {
        if (element.get('name') === 'RDemo') {
          globals.role = 'demo';
        }
      });
    });
  }
  //-----------------------------------------------------------------------------------
  //-------------------------------NOTIFICATIONS----------------------------------------
  newsQuery; // TODO: type

  public newsSubscriptionNotifications() {
    if (!this.newsQuery) {
      this.newsQuery = new parse.Query('BENotifications');
    }
    this.newsQuery.equalTo('user', parse.User.current());
    return this.newsQuery.subscribe();
  }

  //------------------------------------------------------------------------------------
  //-----------------------------END NOTIFICATIONS--------------------------------------

  //-----------------------------------------------------------------------------------
  //-------------------------------EVENTCONNECT----------------------------------------
  public getEventsConnect(theEvent: string): Promise<any> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const EventConnect = parse.Object.extend('BEEventsConnect');
        const query = new parse.Query(EventConnect);
        //query.equalTo("user", parse.User.current());
        const eventPointer = {
          __type: 'Pointer',
          className: 'BEEvents',
          objectId: theEvent
        };
        query.equalTo('event', eventPointer);
        query.equalTo('isEnabled', true);
        query.include(['event', 'guest']);
        query.find().then(
          eventsConnect => {
            resolve(eventsConnect);
          },
          error => {
            reject(error);
          }
        );
      }, 500);
    });
  }

  //-----------------------------------------------------------------------------------
  //---------------------------------------USERS---------------------------------------
  public login(email: string, password: string): Observable<boolean> {
    return new Observable(observer => {
      parse.User.logIn(email, password).then(
        function (user) {
          observer.next(true);
          observer.complete();
        },
        function (error) {
          observer.error(error);
        }
      );
    });
  }

  public register(username: string, password: string): Observable<boolean> {
    return new Observable(observer => {
      const user = new parse.User();
      user.set('username', username);
      user.set('password', password);
      // user.set("email", "email@example.com");
      user.signUp(null).then(
        () => {
          observer.next(true);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        });
    });
  }

  public logout(): Observable<boolean> {
    return new Observable(observer => {
      this._globals.role = '';
      // parse.User.logOut().then(()=> observer.onNext(true))
      parse.User.logOut().then(() => observer.next(true));
      this.name = '';
    });
  }

  public get currentUser() {
    return parse.User.current();
  }
  name = '';

  public getUsername(): Promise<string> {
    if (this.name == '') {
      return new Promise((resolve, reject) => {
        const currentUser = parse.User.current();
        currentUser.fetch({
          success: function (user) {
            const theName = user.get('name');
            this.name = theName;
            resolve(theName);
          }
        });
      });
    } else {
      return Promise.resolve(this.name);
    }
  }
  //-----------------------------------------------------------------------------------
  //-----------------------------------END USERS---------------------------------------
}



// WEBPACK FOOTER //
// ./src/app/service/parse.service.ts